/**
 * /akun layout — nested Stack for the Akun tab (fix P0-3).
 *
 * Without this file, expo-router renders every route inside (main) as a
 * bottom tab, so the 8 akun/* sub-screens (pin, parent-zone, pengaturan,
 * dst) leaked into the tab bar as unlabeled duplicate tabs. Giving akun/
 * its own Stack layout — the same pattern as library/ — keeps exactly
 * 3 tabs (Beranda, Riwayat, Akun) and lets sub-screens push/pop inside
 * the Akun tab.
 */

import { Stack } from 'expo-router';

export default function AkunLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: 'fade',
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="pin" />
      <Stack.Screen name="parent-zone" />
      <Stack.Screen name="edit-profil" />
      <Stack.Screen name="edit-preferensi" />
      <Stack.Screen name="pengaturan" />
      <Stack.Screen name="tentang" />
      <Stack.Screen name="kebijakan-privasi" />
      <Stack.Screen name="syarat-penggunaan" />
      <Stack.Screen name="hapus-data" />
      <Stack.Screen name="ubah-pin" />
    </Stack>
  );
}
